export const ANCHOR_ID = {
  PRECONSTRUCTION_ADDNONS: 'preconstruction-addons',
  CONTENT_PACKS: 'content-packs',
  STANDART_PACKAGE: 'standart-package',
};

export const ADD_BUTTON_TEXT = 'Add';
export const EMPTY_STRING_WITH_WHITESPACE = ' ';
export const EMPTY_STRING = '';
export const STANDART_PACKAGE_ID = '0';
export const SCROLLABLE_CONTAINER_ID = 'scrollable';

export const DEFAULT_ITEM_QUANTITY = 1;
export const MISSING_COUNT_VALUE = 0;
export const MAX_UNFORMATTED_VALUE = 9999;
export const DEFAULT_STEP_VALUE = 1;
export const AUTO_INCREASE_STEP_VALUE = 3;

export const FREE_INCREASING_CONTENT_ITEMS_IDS = ['3', '4'];
export const FREE_INCREASING_ADDONS_ITEMS_IDS = ['10', '11', '12'];
export const FREE_CONTENT_PACKS_ITEM_ID = '5';
export const FREE_ADDONS_ITEM_ID = '13';
export const NON_INCREASING_ITEMS_ID_ARRAY = ['6', '9'];
export const NON_ADDABLE_ID_ARRAY = ['5', '13'];
